"use strict";
var _UpdateStore_data, _UpdateStore_image;
Object.defineProperty(exports, "__esModule", { value: true });
exports.omit = void 0;
const tslib_1 = require("tslib");
const structured_clone_1 = tslib_1.__importDefault(require("@ungap/structured-clone"));
const ImageProvider_1 = tslib_1.__importDefault(require("../../../../services/ImageProvider"));
const updateModel = {
    data: {
        type: 'user',
        attributes: {},
    },
};
class UpdateStore {
    constructor(response) {
        _UpdateStore_data.set(this, void 0);
        _UpdateStore_image.set(this, void 0);
        const payload = (0, structured_clone_1.default)(updateModel);
        payload.data.attributes = (0, exports.omit)(response, ['store_background']);
        tslib_1.__classPrivateFieldSet(this, _UpdateStore_image, response.store_background, "f");
        tslib_1.__classPrivateFieldSet(this, _UpdateStore_data, payload, "f");
    }
    async checkImageBackground() {
        const imageProvider = new ImageProvider_1.default(tslib_1.__classPrivateFieldGet(this, _UpdateStore_image, "f"));
        await imageProvider.upload();
        tslib_1.__classPrivateFieldGet(this, _UpdateStore_data, "f").data.attributes.store_background_image_id =
            imageProvider.image_id;
    }
    get data() {
        if (!tslib_1.__classPrivateFieldGet(this, _UpdateStore_data, "f").data.attributes.store_background_image_id) {
            delete tslib_1.__classPrivateFieldGet(this, _UpdateStore_data, "f").data.attributes.store_background_image_id;
        }
        return tslib_1.__classPrivateFieldGet(this, _UpdateStore_data, "f");
    }
}
exports.default = UpdateStore;
_UpdateStore_data = new WeakMap(), _UpdateStore_image = new WeakMap();
const omit = (object, keys) => {
    if (!object)
        return {};
    try {
        const payload = Object.entries(object).filter(([key]) => !keys.includes(key));
        const data = {};
        payload.forEach((item) => {
            const [key, value] = item;
            data[key] = value;
        });
        return data;
    }
    catch {
        return {};
    }
};
exports.omit = omit;
//# sourceMappingURL=UpdateStore.js.map